enum SelectableType {
  PARTICIPANT = "PARTICIPANT",
  ORGANIZATION = "ORGANIZATION",
  BRAND = "BRAND",
  NONE = "NONE"
}

export default SelectableType;
